export default __webpack_public_path__ + "static/media/q5.4f6d58b9.svg";